export const LANGS = ['ru', 'uz'];

export const T = {
  ru: {
    // Navbar
    nav: {
      services: 'Услуги',
      how: 'Процесс',
      team: 'Команда',
      pricing: 'Цены',
      faq: 'FAQ',
      contacts: 'Контакты',
      call: 'Позвонить',
    },
    // Hero
    hero: {
      pill: 'Фергана · Профессиональный клининг',
      h1a: 'Безупречная',
      h1b: 'чистота',
      h1accent: 'каждый раз',
      sub: 'Качественный результат. Быстрое обслуживание. Никаких лишних затрат.',
      order: 'Заказать уборку',
      callLabel: 'Звонок 24/7',
      chipEco: 'Профессиональный результат',
      chipInsured: 'Опытные специалисты',
      chipGuarantee: 'Подходящая услуга',
      chipCertified: 'Быстро и удобно',
      statClients: 'клиентов',
      statRating: 'рейтинг',
      statRepeat: 'повторных заказов',
      statGuarantee: 'гарантия',
      badgeTitle: 'Гарантия чистоты',
      badgeSub: '',
      reviewText: '«Заказывали генеральную уборку после ремонта — пришли вовремя, отработали идеально. Не осталось ни пылинки, даже плинтусы и батареи блестят. Ребята вежливые, аккуратные, со своей химией. Однозначно будем обращаться снова и рекомендуем всем знакомым!»',
      reviewAuthor: '— Нилуфар А., Фергана',
      ratingLabel: 'Средняя оценка',
      altMain: 'Профессиональная уборка',
      altSmall: 'Чистый интерьер',
      scrollHint: 'Узнать больше',
    },
    // Services
    services: {
      eyebrow: 'Что мы делаем',
      title: 'Наши услуги',
      order: 'Заказать уборку',
      orderCard: 'Заказать →',
      cards: [
        { title:'Уборка квартир и домов', badge:'Популярно', desc:'Стандартная, генеральная или поддерживающая уборка. Любая площадь, любой формат — со своей химией и оборудованием.', tags:['Квартиры','Дома','Коттеджи','Балконы','Генеральная'] },
        { title:'Офисы и коммерция', badge:null, desc:'Офисы, магазины, рестораны, гостиницы и торговые центры. Работаем с объектами любого масштаба.', tags:['Офисы','Магазины','Рестораны','Гостиницы','ТЦ','Склады'] },
        { title:'После ремонта', badge:'Хит', desc:'Строительная пыль, следы краски, цемент и штукатурка — уберём всё до идеального состояния.', tags:['Строит. пыль','Краска','Цемент','Остатки материалов'] },
        { title:'Химчистка мебели', badge:null, desc:'Профессиональная химчистка диванов, кресел, матрасов и ковров. Быстрое высыхание, без запаха.', tags:['Диваны','Кресла','Матрасы','Ковры'] },
        { title:'Мойка окон и витрин', badge:null, desc:'Мойка окон любой высоты без разводов. Своё оборудование, профессиональные средства.', tags:['Окна','Витрины','Высотный клининг'] },
        { title:'Спецуборка', badge:null, desc:'Уборка территорий, чистка вентиляции, глажка одежды и другие специализированные услуги.', tags:['Территории','Вентиляция','Глажка','Парковки'] },
      ],
    },
    // How
    how: {
      eyebrow: 'Процесс',
      title: 'Как мы работаем',
      steps: [
        ['01','Заявка','Оставьте заявку онлайн или позвоните — ответим за 5 минут.'],
        ['02','Расчёт','Наш опытный руководитель оценивает объект и объем работ, а затем рассчитывает стоимость услуги.'],
        ['03','Выезд','Мастера приедут в удобное время со своим оборудованием.'],
        ['04','Результат','Принимаете работу с нами.'],
      ],
    },
    // WhyUs
    whyus: {
      eyebrow: 'Почему мы',
      title: 'Стандарты,\nкоторым доверяют',
      sub: 'Мы выработали стандарты качества, которым следует каждый сотрудник — на каждом объекте.',
      chipLbl: 'довольных\nклиентов',
      order: 'Заказать уборку',
      feats: [
        ['🌿','Профессиональный результат','На основе установленных стандартов, с вниманием к каждой детали.'],
        ['🛡','Опытные специалисты','Профессиональный и ответственный подход к каждому проекту.'],
        ['⏱','Точно в срок','Приезжаем минута в минуту. Ваше время — наша ценность.'],
        ['💎','Подходящая услуга','Персонализированное обслуживание и подход, адаптированный к вашим потребностям.'],
      ],
      altTeam: 'Наша команда',
    },
    // Team
    team: {
      eyebrow: 'Специалисты',
      title: 'Наша команда',
      sub: 'Каждый сотрудник прошёл обучение и проверку. Только профессионалы.',
      statExp: 'лет',
      statRev: 'отзывов',
      statRating: 'рейтинг',
    },
    // Reviews
    reviews: {
      eyebrow: 'Отзывы',
      title: 'Что говорят клиенты',
      loc: 'Фергана',
      items: [
        { name:'Нилуфар Азимова', loc:'ул. Навоий',   text:'Заказала генеральную уборку перед новосельем. Убрали буквально всё — даже внутри шкафов. Квартира просто сияет!', init:'НА', g:'#667eea,#764ba2' },
        { name:'Бахром Алиев',    loc:'Бизнес-центр', text:'Офис 200 м² убирают каждый понедельник. Всегда чисто и свежо. Используют безопасную химию — это важно для сотрудников.', init:'БА', g:'#f093fb,#f5576c' },
        { name:'Малика Каримова', loc:'Хамза',         text:'После ремонта была жуткая пыль везде. Master Clean Pro справились за 5 часов! Цена адекватная, мастера вежливые.', init:'МК', g:'#4facfe,#00C2B8' },
      ],
    },
    // Pricing
    pricing: {
      eyebrow: 'Тарифы',
      title: 'Прозрачные цены',
      sub: 'Никаких скрытых платежей — точная стоимость после заявки',
      popular: 'Популярный',
      order: 'Заказать',
    },
    // FAQ
    faq: {
      eyebrow: 'FAQ',
      title: 'Частые вопросы',
      sub: 'Не нашли ответ? Свяжитесь с нами.',
      ask: 'Задать вопрос',
      altClean: 'Чистое помещение',
      items: [
        { q:'Сколько времени занимает уборка квартиры?', a:'Время уборки зависит от площади, типа уборки и количества уборщиков.' },
        { q:'Нужно ли присутствовать дома во время уборки?', a:'Нет. Все сотрудники проверены. Вы можете передать ключи и вернуться в чистую квартиру.' },
        { q:'Вы используете свои моющие средства?', a:'Да, мы используем профессиональные чистящие средства. При необходимости мы подбираем средства с учетом пожеланий клиента или особенностей поверхности.' },
        { q:'Как рассчитывается стоимость?', a:'Стоимость рассчитывается исходя из площади дома, вида уборки и необходимого количества специалистов. В ходе первичной консультации опытный руководитель оценит ваши потребности и предоставит точный расчет стоимости, составленный специально для вас.' },
        { q:'Работаете ли вы в выходные?', a:'Да, ежедневно с 9:00 до 17:00, включая выходные (за исключением праздников Ид).' },
        { q:'Убираете ли после ремонта?', a:'Да, мы также предоставляем услуги по уборке после ремонта. Мы удаляем строительную пыль, следы загрязнений и строительный мусор, оставляя помещение чистым и готовым к использованию.' },
        { q:'Можно заказать регулярную уборку?', a:'Конечно. Абонементы со скидкой на еженедельную или ежемесячную уборку. Постоянным клиентам — фиксированный мастер.' },
      ],
    },
    // CTA
    cta: {
      title: 'Готовы к идеальной чистоте?',
      sub: 'Оставьте заявку — перезвоним в течение 5 минут',
      btn: 'Оставить заявку',
    },
    // Contact
    contact: {
      eyebrow: 'Контакты',
      title: 'Свяжитесь с нами',
      desc: 'Работаем по всей Фергане. Выезд от 2 часов после заявки.',
      labelPhone: 'Телефон',
      labelTg: 'Telegram',
      labelInsta: 'Instagram',
      labelAddr: 'Адрес',
      labelHours: 'Режим работы',
      formTitle: 'Оставить заявку',
      formSub: 'Ответим в течение 5 минут и рассчитаем стоимость',
      fieldName: 'Ваше имя',
      fieldPhone: 'Телефон',
      fieldService: 'Тип услуги',
      fieldServiceDefault: 'Выберите услугу',
      fieldArea: 'Площадь (м²)',
      fieldDate: 'Удобная дата',
      fieldNote: 'Дополнительно',
      fieldNotePlaceholder: 'Адрес, особые пожелания...',
      submit: 'Отправить заявку',
      submitting: 'Отправка...',
      toastOk: '✓ Заявка отправлена! Перезвоним в течение 5 минут',
      toastErr: 'Ошибка. Попробуйте снова',
      toastValid: 'Введите имя и телефон',
      altTeam: 'Команда',
    },
    // Footer
    footer: {
      tagline: 'Профессиональный клининг в Фергане. Чистота — это наше искусство.',
      colServices: 'Услуги',
      colCompany: 'Компания',
      colContacts: 'Контакты',
      serviceItems: ['Уборка квартир','Генеральная уборка','После ремонта','Офисный клининг','Химчистка мебели','Высотный клининг'],
      companyItems: ['О нас','Наша команда','Отзывы','Партнёрам','Вакансии'],
      copy: '© 2026 MasterClean Pro. Все права защищены. Фергана, Узбекистан.',
      copy2: 'Профессиональный клининг',
    },
    // Fab
    fab: {
      label: 'Свяжитесь с нами',
      call: 'Позвонить',
      tg: 'Telegram',
    },
  },

  uz: {
    // Navbar
    nav: {
      services: 'Xizmatlar',
      how: 'Jarayon',
      team: 'Jamoa',
      pricing: 'Narxlar',
      faq: 'FAQ',
      contacts: 'Kontaktlar',
      call: 'Qo\'ng\'iroq',
    },
    // Hero
    hero: {
      pill: 'Farg\'ona · Professional tozalash',
      h1a: 'Mukammal',
      h1b: 'tozalik',
      h1accent: 'har safar',
      sub: 'Sifatli natija. Tezkor xizmat. Ortiqcha xarajatlarsiz.',
      order: 'Buyurtma berish',
      callLabel: '24/7 qo\'ng\'iroq',
      chipEco: 'Professional natija',
      chipInsured: 'Tajribali mutaxassislar',
      chipGuarantee: 'Sizga mos xizmat',
      chipCertified: 'Tez va qulay',
      statClients: 'mijoz',
      statRating: 'reyting',
      statRepeat: 'takroriy buyurtmalar',
      statGuarantee: 'kafolat',
      badgeTitle: 'Tozalik kafolati',
      badgeSub: '',
      reviewText: '«Ta\'mirdan keyin bosh tozalashni buyurtma qildik — o\'z vaqtida kelishdi, mukammal ishladilar. Bir zarra chang ham qolmadi, hatto plintuslar va radiatorlar ham porlab turibdi. Yigitlar muloyim, ozoda, o\'z kimyolari bilan. Albatta yana murojaat qilamiz va barcha tanishlarimizga tavsiya qilamiz!»',
      reviewAuthor: '— Nilufar A., Farg\'ona',
      ratingLabel: 'O\'rtacha baho',
      altMain: 'Professional tozalash',
      altSmall: 'Toza ichki ko\'rinish',
      scrollHint: 'Batafsil',
    },
    // Services
    services: {
      eyebrow: 'Biz nima qilamiz',
      title: 'Bizning xizmatlar',
      order: 'Tozalash buyurtma qilish',
      orderCard: 'Buyurtma →',
      cards: [
        { title:'Kvartira va uylarni tozalash', badge:'Mashhur', desc:'Standart, bosh yoki qo\'llab-quvvatlovchi tozalash. Istalgan maydon, istalgan format — o\'z kimyoviy moddalari va uskunalari bilan.', tags:['Kvartiralari','Uylar','Kottejlar','Balkonlar','Bosh tozalash'] },
        { title:'Ofis va tijorat', badge:null, desc:'Ofislar, do\'konlar, restoranlar, mehmonxonalar va savdo markazlari. Istalgan ko\'lamdagi ob\'ektlar bilan ishlaymiz.', tags:['Ofislar','Do\'konlar','Restoranlar','Mehmonxonalar','SM','Omborlar'] },
        { title:'Ta\'mirdan keyin', badge:'Hit', desc:'Qurilish changi, bo\'yoq izlari, tsement va gips — hammasini ideal holatga keltiramiz.', tags:['Qurilish changi','Bo\'yoq','Tsement','Qurilish qoldiqlari'] },
        { title:'Mebel kimyoviy tozalash', badge:null, desc:'Divanlar, kreslolar, matraslar va gilamlarni professional kimyoviy tozalash. Tez qurishadi, hidsiz.', tags:['Divanlar','Kreslolar','Matraslar','Gilamlar'] },
        { title:'Oyna va vitrinalarni yuvish', badge:null, desc:'Istalgan balandlikdagi oynalarni dog\'siz yuvish. O\'z uskunalari, professional vositalar.', tags:['Oynalar','Vitrinalar','Baland tozalash'] },
        { title:'Maxsus tozalash', badge:null, desc:'Hududlarni tozalash, ventilyatsiyani tozalash, kiyimlarni daqlash va boshqa ixtisoslashgan xizmatlar.', tags:['Hududlar','Ventilyatsiya','Daqlash','Avtoturargohlar'] },
      ],
    },
    // How
    how: {
      eyebrow: 'Jarayon',
      title: 'Biz qanday ishlaymiz',
      steps: [
        ['01','Ariza','Onlayn ariza qoldiring yoki qo\'ng\'iroq qiling — 5 daqiqa ichida javob beramiz.'],
        ['02','Hisob-kitob','Ekspert-supervayzerimiz obyekt va ish hajmini baholab, xizmat narxini hisoblaydi.'],
        ['03','Chiqish','Tozalovchilarimiz kelishilgan vaqtda obyektga yetib keladi va ishni boshlaydi.'],
        ['04','Natija','Tozalash yakunlangach, mijoz bajarilgan ishni tekshiradi va natijani qabul qilib oladi.'],
      ],
    },
    // WhyUs
    whyus: {
      eyebrow: 'Nima uchun biz',
      title: 'Ishonch\nbildirilgan standartlar',
      sub: 'Har bir xodim har bir obyektda rioya qiladigan sifat standartlarini ishlab chiqdik.',
      chipLbl: 'mamnun\nmijozlar',
      order: 'Tozalash buyurtma qilish',
      feats: [
        ['🌿','Professional natija','Belgilangan standartlar asosida, har bir detalga e\'tibor bilan.'],
        ['🛡','Tajribali mutaxassislar','Har bir obyektga professional va mas\'liyatli yondashuv.'],
        ['⏱','O\'z vaqtida','Daqiqa-daqiqa kelamiz. Vaqtingiz — bizning qadriyatimiz.'],
        ['💎','Sizga mos xizmat','Ehtiyojingizga qarab individual xizmat va yondashuv.'],
      ],
      altTeam: 'Bizning jamoa',
    },
    // Team
    team: {
      eyebrow: 'Bizning xodimlar',
      title: 'Bizning jamoa',
      sub: 'Har bir xodim o\'qitilgan va tekshirilgan. Faqat professionallar.',
      statExp: 'yil',
      statRev: 'sharh',
      statRating: 'reyting',
    },
    // Reviews
    reviews: {
      eyebrow: 'Sharhlar',
      title: 'Mijozlar nima deydi',
      loc: 'Farg\'ona',
      items: [
        { name:'Nilufar Azimova', loc:'Navoiy ko\'chasi', text:'Yangi uyga ko\'chishdan oldin bosh tozalash buyurtma qildim. Hamma narsani tozaladilar — shkaflar ichini ham. Kvartira porlab turibdi!', init:'НА', g:'#667eea,#764ba2' },
        { name:'Baxrom Aliev',    loc:'Biznes-markaz',   text:'200 m² ofisni har dushanba kuni tozalashadi. Doim toza va yangi. Xavfsiz kimyo ishlatishadi — bu xodimlar uchun muhim.', init:'БА', g:'#f093fb,#f5576c' },
        { name:'Malika Karimova', loc:'Xamza',            text:'Ta\'mirdan keyin hamma yerda qo\'rqinchli chang bor edi. Master Clean Pro 5 soatda hal qildi! Narx maqul, xodimlar muloyim.', init:'МК', g:'#4facfe,#00C2B8' },
      ],
    },
    // Pricing
    pricing: {
      eyebrow: 'Tariflar',
      title: 'Shaffof narxlar',
      sub: 'Hech qanday yashirin to\'lovlar yo\'q — arizadan keyin aniq narx',
      popular: 'Mashhur',
      order: 'Buyurtma',
    },
    // FAQ
    faq: {
      eyebrow: 'FAQ',
      title: 'Ko\'p so\'raladigan savollar',
      sub: 'Javob topmadingizmi? Biz bilan bog\'laning.',
      ask: 'Savol berish',
      altClean: 'Toza xona',
      items: [
        { q:'Kvartira tozalash qancha vaqt oladi?', a:'Tozalash vaqti maydon, tozalash turi va tozalovchi soniga bog\'liq.'},
        { q:'Tozalash paytida uyda bo\'lish kerakmi?', a:'Yo\'q. Barcha xodimlar tekshirilgan. Kalitni topshirib, toza kvartirangizga qaytishingiz mumkin.' },
        { q:'O\'z yuvish vositalaringizdan foydalanasizmi?', a:'Ha, biz professional tozalash vositalaridan foydalanamiz. Zarur bo\'lsa, mijozning xohishiga yoki yuzaning xususiyatiga mos vositalarni tanlaymiz.' },
        { q:'Narx qanday hisoblanadi?', a:'Narx uy maydoni, tozalash turi va kerakli tozalovchilar soniga qarab belgilanadi. Dastlabki suhbat davomida ekspert-supervayzor ehtiyojlaringizni aniqlab, sizga individual va aniq narx taklif qiladi.' },
        { q:'Dam olish kunlari ham ishlaysizmi?', a:'Ha, har kuni soat 9:00 dan 17:00 gacha, dam olish kunlari ham(Hayit bayramlaridan tashqari).' },
        { q:'Ta\'mirdan keyin tozalaysizmi?', a:'Ha, ta\'mirdan keyingi tozalash xizmatini ham ko\'rsatamiz. Qurilishdan qolgan chang, izlar va qoldiqlarni bartaraf etib, makoningizni toza va tayyor holatga keltiramiz.' },
        { q:'Muntazam tozalash buyurtma qilish mumkinmi?', a:'Albatta. Haftalik yoki oylik tozalash uchun chegirmali obunalar. Doimiy mijozlarga — belgilangan tozalovchi.' },
      ],
    },
    // CTA
    cta: {
      title: 'Ideal tozalikka tayyormisiz?',
      sub: 'Ariza qoldiring — 5 daqiqa ichida qayta qo\'ng\'iroq qilamiz',
      btn: 'Ariza qoldirish',
    },
    // Contact
    contact: {
      eyebrow: 'Kontaktlar',
      title: 'Biz bilan bog\'laning',
      desc: 'Butun Farg\'ona bo\'ylab ishlaymiz. Arizadan 2 soat ichida chiqamiz.',
      labelPhone: 'Telefon',
      labelTg: 'Telegram',
      labelInsta: 'Instagram',
      labelAddr: 'Manzil',
      labelHours: 'Ish vaqti',
      formTitle: 'Ariza qoldirish',
      formSub: '5 daqiqa ichida javob beramiz va narxni hisoblaymiz',
      fieldName: 'Ismingiz',
      fieldPhone: 'Telefon',
      fieldService: 'Xizmat turi',
      fieldServiceDefault: 'Xizmatni tanlang',
      fieldArea: 'Maydon (m²)',
      fieldDate: 'Qulay sana',
      fieldNote: 'Qo\'shimcha',
      fieldNotePlaceholder: 'Manzil, maxsus xohishlar...',
      submit: 'Ariza yuborish',
      submitting: 'Yuborilmoqda...',
      toastOk: '✓ Ariza yuborildi! 5 daqiqa ichida qayta qo\'ng\'iroq qilamiz',
      toastErr: 'Xatolik. Qayta urinib ko\'ring',
      toastValid: 'Ism va telefon kiriting',
      altTeam: 'Jamoa',
    },
    // Footer
    footer: {
      tagline: 'Farg\'onada professional tozalash. Tozalik — bu bizning san\'atimiz.',
      colServices: 'Xizmatlar',
      colCompany: 'Kompaniya',
      colContacts: 'Kontaktlar',
      serviceItems: ['Kvartiralarni tozalash','Bosh tozalash','Ta\'mirdan keyin','Ofis tozalash','Mebel kimyoviy tozalash','Baland tozalash'],
      companyItems: ['Biz haqimizda','Bizning jamoa','Sharhlar','Hamkorlar','Vakansiyalar'],
      copy: '© 2026 MasterClean Pro. Barcha huquqlar himoyalangan. Farg\'ona, O\'zbekiston.',
      copy2: 'Professional tozalash',
    },
    // Fab
    fab: {
      label: 'Biz bilan bog\'laning',
      call: 'Qo\'ng\'iroq',
      tg: 'Telegram',
    },
  },
};
